'use client'

import { Notification as NotificationPrimitives } from './Notification'
import { getRenderer } from './renderers'
import type { NotificationViewProps } from './renderers'

/** Entrada "inteligente": escolhe o renderer pelo `type_id` do item. */
function Preview(props: NotificationViewProps) {
  const Renderer = getRenderer(props.notification.type_id).Preview
  return <Renderer {...props} />
}

function Full(props: NotificationViewProps) {
  const Renderer = getRenderer(props.notification.type_id).Full
  return <Renderer {...props} />
}

/**
 * Composição pública:
 *
 *   <Notification.Preview notification={n} href="…" />   ← lista/popover
 *   <Notification.Full notification={n} />               ← detalhe/modal
 *
 * Primitivas (pra dentro de renderers custom):
 *   <Notification notification={n}>
 *     <Notification.KindIcon /> .KindBadge .Title .Body .Time .Target .Meta
 *     .ReadAction .DeleteAction
 *   </Notification>
 */
export const Notification = Object.assign(NotificationPrimitives, { Preview, Full })

export { getRenderer } from './renderers'
export type { NotificationRenderer, NotificationViewProps } from './renderers'
